export default "__VITE_ASSET__BcYZsYgu__"